import { createLoginUrl } from 'lib/utils/request';

const ExternalLoginRedirect = () => {
  const loginUrl = createLoginUrl();
  window.location = loginUrl;
  return null;
};

export { ExternalLoginRedirect };
